import React, { useEffect , useState } from 'react';

import {
  Card,
  CardBody,
  Container
} from 'reactstrap';


const Confirmation = ({ next_step , prev_step , email }) => {

  useEffect(() => {
    
  },[]);


  return (

  <Container className="mt-3 d-flex justify-content-center align-items-center">
    
    <Card className='w-50'>
  
           <CardBody>

<p className='fs-4 fst-italic fw-bold'>
   Congratulations!
</p>


<p>
You have registered successfully.
</p>

<p>
<h6 className='fst-italic text-decoration-underline'>What next?</h6>
We will review your details, set up your account, and email({email}) your login credentials.
</p>

<p>
 Thank you for choosing Itoagent! We are excited to have you on board.
</p>

    </CardBody>
</Card>

   </Container>
  )
}

export default Confirmation;
